module.exports = __webpack_public_path__ + "static/media/6b44fd100352349.5f07015fe3d69.89d94aef.jpg";